import { useState, type ReactNode, useCallback } from 'react';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import { cn } from '@simplywallst/ui-core/next';

import ChevronUpSmallSolid from '@simplywallst/ui-core/icons/ChevronUpSmallSolid';

export const ScrollToTop = ({ children }: { children: ReactNode }) => {
  const [state, setState] = useState(false);

  const handleIntersectionChange = useCallback(
    (args: IntersectionObserverEntry) => {
      const { boundingClientRect } = args;
      if (boundingClientRect.top < 0) {
        setState(true);
      } else {
        setState(false);
      }
    },
    []
  );

  const sticky = cn(
    'sticky left-full z-sticky mt-x1 w-x6 pb-[env(safe-area-inset-bottom)] pr-x1 transition-[bottom] lg:mt-x4 lg:w-x11 lg:pr-x7',
    state ? 'bottom-x8 lg:bottom-x5' : '-bottom-x8 lg:-bottom-x5'
  );

  return (
    <div
      id="top"
      data-theme="light"
      // scroll-mt-[5000px] to hack a guaranteed "top" placement
      className="relative scroll-mt-[5000px] bg-surface-1 pb-x1 lg:pb-x3"
    >
      {children}
      <div className={sticky}>
        <a
          href="#top"
          className="grid size-x5 place-content-center rounded-x5 bg-brand-01"
        >
          <ChevronUpSmallSolid className="fill-p-white-100" />
        </a>
      </div>
      {/* Placing a hidden intersection trigger */}
      <IntersectionObserver threshold={[1]} onChange={handleIntersectionChange}>
        <div className="absolute top-[20vh] z-sticky size-0 bg-attention" />
      </IntersectionObserver>
    </div>
  );
};
